<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.bargains'), $t('text.view')]">
      </breadcrumb>

      <div class="container pd20">
        <el-tabs v-model="activeName" @tab-click="handleClickTab">
          <el-tab-pane :label="$t('bargain.bargainInfo')" name="detail">
            <div class="drawer-content with-tab">
              <el-form ref="bargainForm" :model="bargain" label-width="100px">
                <fieldset class="mgb15">
                  <el-row :gutter="10">
                    <el-col :span="8">
                      <el-form-item :label="$t('bargain.serialNo')">
                        {{ bargain.serialNo }}
                      </el-form-item>
                    </el-col>
                    <el-col
                      v-if="Permit.canActions('globalSalePrice')"
                      :span="8"
                    >
                      <el-form-item :label="$t('bargain.saleAmount')">
                        <currency :code="bargain.currency"></currency>
                        {{ bargain.productAmount }}
                      </el-form-item>
                    </el-col>
                    <el-col
                      v-if="Permit.canActions('globalSalePrice')"
                      :span="8"
                    >
                      <el-form-item :label="$t('bargain.amount')">
                        <currency :code="bargain.currency"></currency>
                        {{ bargain.amount }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col
                      v-if="Permit.canActions('globalSalePrice')"
                      :span="8"
                    >
                      <el-form-item :label="$t('bargain.payAmount')">
                        <span v-if="bargain.settleType == 'later'">{{
                          $t("settleTypes.later")
                        }}</span>
                        <span v-else>
                          <span class="mgr5">
                            <span v-if="bargain.ignoreAmount !== 0"
                              >{{ $t("bargain.receive") }}:</span
                            >
                            <currency :code="bargain.currency"></currency>
                            {{ bargain.payAmount }}
                          </span>
                          <span v-if="bargain.ignoreAmount > 0" class="mr5">
                            {{ $t("bargain.ignore") }}:
                            <currency :code="bargain.currency"></currency>
                            {{ bargain.ignoreAmount }}
                          </span>
                        </span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item :label="$t('user.shop')">
                        {{ bargain.shopName }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item :label="$t('text.owner')">
                        {{ bargain.ownerName }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="8">
                      <el-form-item :label="$t('text.createAt')">
                        {{ bargain.createAt }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="16">
                      <el-form-item :label="$t('bargain.deliveryRemark')">
                        {{ bargain.deliveryRemark }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="8" v-if="bargain.iossNum != null">
                      <el-form-item :label="$t('shop.iossNum')">
                        {{ bargain.iossNum }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                </fieldset>
                <fieldset
                  v-if="bargain.remark != null && bargain.remark != ''"
                  class="mgb15"
                >
                  <legend>{{ $t("text.remark") }}</legend>
                  <raw-html :content="bargain.remark" />
                </fieldset>
                <fieldset class="mgb10">
                  <legend>{{ $t("bargain.customerInfo") }}</legend>
                  <el-row :gutter="10">
                    <el-col :span="8">
                      <el-form-item :label="$t('bargain.customerName')">
                        {{ bargain.customerName }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item :label="$t('bargain.customerPhone')">
                        {{ bargain.customerPhone }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item :label="$t('bargain.customerZipcode')">
                        {{ bargain.customerZipcode }}
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="24">
                      <el-form-item :label="$t('bargain.customerAddress')">
                        <span>
                          <span v-if="bargain.customerCountry != null">
                            {{ $t("countries." + bargain.customerCountry) }}
                          </span>
                          {{ bargain.customerProvince }}{{ bargain.customerCity
                          }}{{ bargain.customerAddress }}
                        </span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </fieldset>
                <fieldset
                  v-if="
                    Permit.canActions('orderPaymentView') &&
                    bargain.settleType == 'now'
                  "
                  class="mgb10"
                >
                  <legend>
                    {{ $t("bargain.paymentInfo") }}
                    <span class="float-right mgr10">
                      <span class="mgr5">
                        {{ $t("bargain.receive") }}:
                        <currency :code="bargain.currency"></currency>
                        {{ bargain.payAmount }}
                      </span>
                      <span v-if="bargain.ignoreAmount > 0" class="mr5">
                        {{ $t("bargain.ignore") }}:
                        <currency :code="bargain.currency"></currency>
                        {{ bargain.ignoreAmount }}
                      </span>
                    </span>
                  </legend>
                  <vxe-table
                    :data="bargain.payments"
                    size="mini"
                    highlight-hover-row
                    :scroll-y="{ enabled: false }"
                  >
                    <vxe-table-column
                      field="total"
                      :title="$t('payment.total')"
                    >
                      <template v-slot="{ row }">
                        <currency :code="row.currency"></currency>
                        {{ row.total }}
                      </template>
                    </vxe-table-column>
                    <vxe-table-column
                      field="payMethodName"
                      :title="$t('payment.payMethod')"
                    ></vxe-table-column>
                    <vxe-table-column
                      field="paidAt"
                      :title="$t('payment.paidAt')"
                      width="110px"
                    ></vxe-table-column>
                    <vxe-table-column
                      field="ownerName"
                      :title="$t('payment.ownerName')"
                    ></vxe-table-column>
                    <vxe-table-column
                      field="voucher"
                      :title="$t('payment.voucher')"
                    >
                      <template v-slot="{ row }">
                        <thumbnail-text :srcs="row.voucher" />
                      </template>
                    </vxe-table-column>
                    <vxe-table-column
                      field="explain"
                      :title="$t('payment.explain')"
                    ></vxe-table-column>
                    <vxe-table-column
                      v-if="
                        Permit.canActionsChargeEdition('orderAddPayment') &&
                        financeVerifyInfoDF()
                      "
                      field="action"
                      :title="$t('text.action')"
                    >
                      <template v-slot="{ row, rowIndex }">
                        <el-button
                          v-if="row.payMethodId != -1 && row.payMethodId != 0"
                          type="text"
                          size="mini"
                          @click="editPayment(row, rowIndex)"
                          >{{ $t("text.edit") }}</el-button
                        >
                        <el-button
                          type="text"
                          size="mini"
                          @click="deletePayment(row, rowIndex)"
                          >{{ $t("text.delete") }}</el-button
                        >
                      </template>
                    </vxe-table-column>
                  </vxe-table>
                </fieldset>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('menu.orders')" name="order">
            <narrow
              :narrows="narrows"
              :init-filter="initFilter"
              @narrowSelect="narrowSelect"
            />
            <div class="search with-narrows">
              <el-form
                :inline="true"
                @submit.native.prevent="search"
                :model="searchForm"
                size="small"
              >
                <el-form-item>
                  <el-input
                    size="small"
                    v-model.trim="searchForm.serialNo"
                    :placeholder="$t('text.serialNo')"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    size="small"
                    v-model.trim="searchForm.productNo"
                    :placeholder="$t('product.productNo')"
                  ></el-input>
                </el-form-item>
                <el-form-item :prop="'categoryId'">
                  <el-select
                    size="small"
                    v-model="searchForm.categoryName"
                    :placeholder="$t('product.category')"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="category in categories"
                      :key="category.id"
                      :label="category.name"
                      :value="category.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    size="small"
                    v-model.trim="searchForm.color"
                    :placeholder="$t('product.color')"
                  />
                </el-form-item>
                <el-form-item>
                  <el-input
                    size="small"
                    v-model.trim="searchForm.size"
                    :placeholder="$t('product.size')"
                  />
                </el-form-item>
                <el-form-item>
                  <el-input
                    size="small"
                    v-model.trim="searchForm.specJson"
                    :placeholder="$t('product.specJson')"
                  />
                </el-form-item>

                <el-form-item v-if="!Permit.isFreeEdition()">
                  <el-select
                    size="small"
                    v-model.trim="searchForm.ownerId"
                    :placeholder="$t('text.owner')"
                  >
                    <el-option
                      v-for="user in users"
                      :key="user.id"
                      :label="user.name"
                      :value="user.id"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item>
                  <date-range
                    size="small"
                    v-model="searchForm"
                    type="datetime"
                    field="createAt"
                    :start-placeholder="
                      $t('rules.startAt', [$t('text.createAt')])
                    "
                    :end-placeholder="$t('rules.endAt', [$t('text.createAt')])"
                  />
                </el-form-item>
                <el-form-item>
                  <date-range
                    size="small"
                    v-model="searchForm"
                    type="datetime"
                    field="finishAt"
                    :start-placeholder="
                      $t('rules.startAt', [$t('dateTypes.finishAt')])
                    "
                    :end-placeholder="
                      $t('rules.endAt', [$t('dateTypes.finishAt')])
                    "
                  />
                </el-form-item>
                <el-form-item>
                  <date-range
                    size="small"
                    v-model="searchForm"
                    type="datetime"
                    field="customerReceiveAt"
                    :start-placeholder="
                      $t('rules.startAt', [$t('dateTypes.customerReceiveAt')])
                    "
                    :end-placeholder="
                      $t('rules.endAt', [$t('dateTypes.customerReceiveAt')])
                    "
                  />
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    icon="el-icon-search"
                    native-type="submit"
                  />
                </el-form-item>
              </el-form>
            </div>
            <div class="wrapper table-area">
              <sticky
                :sticky-top="50"
                :viewport="1024"
                :is-rem="false"
                style="min-height: 52px"
              >
                <vxe-toolbar
                  ref="recordsToolbar"
                  custom
                  zoom
                  class="table-toolbar"
                >
                  <template v-slot:buttons>
                    <el-button
                      v-if="Permit.canActionsChargeEdition('orderConfirm')"
                      type="success"
                      size="mini"
                      @click="batchConfirm"
                      >{{ $t("action.confirmBargain") }}</el-button
                    >
                    <el-dropdown @command="selectFlag" class="mgl10">
                      <el-button type="default" size="mini">
                        {{ $t("action.flag") }}
                        <i class="el-icon-arrow-down el-icon--right"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          v-for="(flag, index) in flags"
                          :key="index"
                          :command="flag"
                        >
                          <flag :name="flag" />
                          {{ $t("flags." + flag) }}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>

                    <el-dropdown class="mgl10" @command="download">
                      <el-button type="default" size="mini">
                        {{ $t("action.download") }}
                        <i class="el-icon-caret-bottom el-icon--right" />
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="checked">{{
                          $t("action.downLoadChecked")
                        }}</el-dropdown-item>
                        <el-dropdown-item command="search">{{
                          $t("action.downLoadSearch")
                        }}</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>

                    <el-button
                      type="default"
                      size="mini"
                      class="mgl10"
                      @click="print('printListDiv')"
                    >
                      {{ $t("action.print") }}
                    </el-button>

                    <span class="pager-total">
                      {{ $t("rules.pagerTotal", [pager.total]) }}，
                      <!-- {{ pager.productNoQty }} 款 {{ pager.qtyTotal }} 件, 成交额{{
                  pager.moneyTotal | currency
                }} --><span v-if="saleSearchCount != null">
                        <span class="mgr5">
                          {{ saleSearchCount.productNoQty }} 款
                          {{ saleSearchCount.qtyTotal }} 件，成交额{{
                            saleSearchCount.moneyTotal | currency
                          }}
                        </span>
                        <span
                          v-if="
                            Permit.canActionsConfigDealType('available') &&
                            Permit.canActions('orderDeal-available')
                          "
                        >
                          现货: {{ saleSearchCount.availableProductNoQty }} 款
                          {{ saleSearchCount.availableQtyTotal }} 件
                        </span>
                        <span
                          v-if="
                            Permit.canActionsConfigDealType('manufacture') &&
                            Permit.canActions('orderDeal-manufacture')
                          "
                        >
                          / 生产:
                          {{ saleSearchCount.manufactureProductNoQty }} 款
                          {{ saleSearchCount.manufactureQtyTotal }} 件
                        </span>
                        <span
                          v-if="
                            Permit.canActionsConfigDealType('purchase') &&
                            Permit.canActionsChargeEdition('orderDeal-purchase')
                          "
                        >
                          / 外采: {{ saleSearchCount.purchaseProductNoQty }} 款
                          {{ saleSearchCount.purchaseQtyTotal }} 件
                        </span>
                      </span>
                    </span>
                  </template>
                </vxe-toolbar>
              </sticky>
              <vxe-table
                :data="records"
                @checkbox-change="setSelected"
                @checkbox-all="setSelected"
                @sort-change="sortRecords"
                :sort-config="{ remote: true }"
                :checkbox-config="{ reserve: true }"
                :custom-config="{
                  storage: true,
                  checkMethod: checkColumnMethod,
                }"
                ref="recordsTable"
                class="recordsTable"
                :row-class-name="rowBgColor"
                size="mini"
                id="pendingsTable"
                row-id="id"
                :loading="loading"
                resizable
                round
                highlight-hover-row
                auto-resize
                :scroll-y="{ enabled: false }"
              >
                <vxe-table-column
                  field="checkbox"
                  type="checkbox"
                  width="35"
                ></vxe-table-column>
                <vxe-table-column
                  field="flags"
                  :title="$t('text.flag')"
                  width="50"
                >
                  <template v-slot="{ row }">
                    <span v-if="row.flags != null && row.flags != ''">
                      <flag
                        :name="flag"
                        :size="14"
                        v-for="flag in JSON.parse(row.flags)"
                        :key="flag"
                      ></flag>
                    </span>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="images"
                  :title="$t('product.images')"
                  width="85"
                >
                  <template v-slot="{ row }">
                    <thumbnail :images="row.images"></thumbnail>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="serialNo"
                  :title="$t('text.serialNo')"
                  min-width="120"
                >
                  <template v-slot="{ row, rowIndex }">
                    <small v-if="row.hurry" class="red"
                      >({{ $t("order.hurrySimple") }})</small
                    >
                    <span @click="showRecord(row, rowIndex)" class="font10">
                      <s v-if="row.workflowState == 'canceled'" class="grey">{{
                        row.serialNo
                      }}</s>
                      <span v-else class="blue">{{ row.serialNo }}</span>
                    </span>
                    <div class="font10">{{ row.innerSerialNo }}</div>
                    <div>
                      <state-label
                        :state="row.workflowState"
                        :permit="Permit.canActions('orderDealView')"
                      >
                        <span v-if="Permit.canActions('orderDealView')">{{
                          $t("orderStates." + row.workflowState)
                        }}</span>
                        <span v-else>{{
                          $t("orderStatesNoPermit." + row.workflowState)
                        }}</span>
                      </state-label>
                      <span v-if="row.isScore == true" class="font10 green">{{
                        $t("order.isScore")
                      }}</span>
                    </div>
                    <div
                      v-if="row.labelsJson != null && row.labelsJson != ''"
                      class="font10"
                    >
                      {{ JSON.parse(row.labelsJson).join(",") }}
                    </div>
                    <div
                      v-if="row.settlementId != null && row.settlementId != 0"
                      class="green font10"
                    >
                      {{ $t("purchase.settlement") }}:{{ row.settleAt }}
                    </div>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="handOverAt"
                  :title="$t('text.handOverAt')"
                  min-width="120"
                  sortable
                >
                  <template v-slot="{ row }">
                    {{ row.handOverAt }}
                    <div
                      v-if="!Permit.isFreeEdition() && row.confirmAt != null"
                      class="font10 green"
                    >
                      {{ $t("order.confirm") }}:{{ row.confirmAt }}
                    </div>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="productNo"
                  :title="$t('product.productNo')"
                  min-width="100"
                >
                  <template v-slot="{ row }">
                    {{ row.productNo }}
                    <small
                      v-if="
                        row.customerProductNo != null &&
                        row.customerProductNo != ''
                      "
                      >({{ row.customerProductNo }})</small
                    >

                    <div class="font10">
                      {{ row.categoryName }}
                      <span v-if="row.productBrand != null">/</span>
                      {{ row.productBrand }}
                    </div>
                    <div class="font10">
                      <span
                        :class="
                          row.color != null &&
                          row.color != '' &&
                          !Util.regexChinese(row.color)
                            ? 'red'
                            : ''
                        "
                        >{{ row.color }}</span
                      >
                      {{ row.size }}
                    </div>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="remark"
                  :title="$t('text.remark')"
                  min-width="150"
                >
                  <template v-slot="{ row }">
                    <raw-html-limit-number
                      :content="row.remark"
                      :number="12"
                      type="richText"
                    />
                    <div
                      class="orange font10"
                      v-if="row.orderRemark != null && row.orderRemark != ''"
                    >
                      {{ $t("order.orderRemark") }}:
                      <raw-html-limit-number
                        :content="row.orderRemark"
                        :number="12"
                      />
                    </div>
                    <div
                      class="orange font10"
                      v-if="
                        row.settlementRemark != null &&
                        row.settlementRemark != ''
                      "
                    >
                      {{ $t("order.settlementRemark") }}:
                      <raw-html-limit-number
                        :content="row.settlementRemark"
                        :number="6"
                      />
                    </div>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="specJson"
                  :title="$t('product.specJson')"
                  min-width="100"
                >
                  <template v-slot="{ row }">
                    <attribute :content="row.specJson" :number="12" />
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  v-if="Permit.canActions('globalSalePrice')"
                  field="price"
                  :title="$t('order.price')"
                  min-width="100"
                >
                  <template v-slot="{ row, rowIndex }">
                    <span v-if="row.isScore == true"
                      >{{ row.score
                      }}<span class="font10">{{
                        $t("product.score")
                      }}</span></span
                    >
                    <span v-else>
                      <currency :code="row.currency"></currency>
                      {{ row.price }}
                      <small
                        v-if="row.discountRate != null && row.discountRate != 0"
                        >({{ row.discountRate }}%)</small
                      >
                      <div
                        v-if="row.extraCharge != null && row.extraCharge != 0"
                        class="font10"
                      >
                        {{ $t("order.extraChargeSimple") }}:
                        <currency :code="row.currency"></currency>
                        {{ row.extraCharge }}
                      </div>
                      <div class="font8">
                        {{ $t("order.salePriceSimple") }}:
                        <currency :code="row.currency"></currency
                        >{{ row.productPrice }}
                      </div>
                      <div
                        v-if="row.follow == false && row.settlementId != 0"
                        class="font10"
                      >
                        {{ $t("product.quotation") }}:
                        <currency :code="row.currency"></currency
                        >{{ row.quotedPrice }}
                        <i
                          v-if="row.settlementId == null"
                          slot="reference"
                          class="el-icon-edit fl"
                          @click="editQuotedPrice(row, rowIndex)"
                        />
                      </div>
                    </span>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="quantity"
                  :title="$t('text.quantity')"
                  min-width="80"
                >
                  <template v-slot="{ row }">
                    {{ row.quantity }}{{ row.unit || "" }}
                    <div class="font10">
                      <el-popover
                        placement="right"
                        width="800"
                        trigger="click"
                        @show="getDeliveries(row)"
                      >
                        <vxe-table
                          :data="deliveries"
                          id="deliverInfosTable"
                          row-id="id"
                          ref="deliverInfosTable"
                          class="recordsTable"
                          size="mini"
                          resizable
                          round
                          auto-resize
                          highlight-hover-row
                          :scroll-y="{ enabled: false }"
                        >
                          <vxe-table-column
                            field="deliverType"
                            :title="$t('delivery.deliveryMethode')"
                          >
                            <template v-slot="{ row }">
                              <span v-if="row.deliverType != null">{{
                                $t("deliverTypes." + row.deliverType)
                              }}</span>
                            </template>
                          </vxe-table-column>
                          <vxe-table-column
                            field="express"
                            :title="$t('delivery.express')"
                          />
                          <vxe-table-column
                            field="deliverMethodName"
                            :title="$t('delivery.channel')"
                          />
                          <vxe-table-column
                            field="tracking"
                            :title="$t('delivery.tracking')"
                          />
                          <vxe-table-column
                            field="attachment"
                            :title="$t('product.attachment')"
                          >
                            <template v-slot="{ row }">
                              <thumbnail-text
                                :srcs="row.attachment"
                                :text="'附件'"
                              />
                            </template>
                          </vxe-table-column>
                          <vxe-table-column
                            field="deliverBy"
                            :title="$t('delivery.deliverBy')"
                          />
                          <vxe-table-column
                            field="deliverAt"
                            :title="$t('delivery.deliverAt')"
                          />
                          <vxe-table-column
                            field="remark"
                            :title="$t('bargain.deliveryRemark')"
                          >
                            <template v-slot="{ row }">
                              <raw-html-limit-number
                                :content="row.remark"
                                :number="12"
                              />
                            </template>
                          </vxe-table-column>
                        </vxe-table>
                        <span slot="reference" class="popover-reference">
                          {{ $t("order.delivered") }}:{{ row.deliveredQuantity
                          }}{{ row.unit || "" }}
                        </span>
                      </el-popover>
                    </div>
                    <div v-if="row.customerReceiveAt != null" class="font10">
                      {{ $t("order.customerReceiveAt") }}:{{
                        row.customerReceiveAt
                      }}
                    </div>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="dealType"
                  :title="$t('order.dealType')"
                  min-width="80"
                >
                  <template v-slot="{ row }">
                    <span v-if="row.dealType !== null">{{
                      $t("orderDealTypes." + row.dealType)
                    }}</span>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  field="createAt"
                  :title="$t('text.createAt')"
                  min-width="110"
                />
                <vxe-table-column
                  field="action"
                  :title="$t('text.action')"
                  width="120"
                >
                  <template v-slot="{ row, rowIndex }">
                    <el-dropdown
                      v-if="
                        row.follow == true &&
                        Permit.canActionsChargeEdition('orderManage') &&
                        !['canceled', 'returned'].includes(row.workflowState)
                      "
                      class="mgr10"
                    >
                      <a class="el-dropdown-link small-link">
                        {{ $t("text.edit") }}
                        <i class="el-icon-arrow-down el-icon--right"></i>
                      </a>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          v-if="
                            [
                              'confirming',
                              'pending',
                              'preparing',
                              'processing',
                              'purchasing',
                            ].includes(row.workflowState)
                          "
                        >
                          <div class="font10" @click="editOrder(row, rowIndex)">
                            {{ $t("text.edit") }}
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item
                          v-if="
                            !['canceled', 'returned'].includes(
                              row.workflowState
                            )
                          "
                        >
                          <div
                            class="font10"
                            @click="editOrderPrice(row, rowIndex)"
                          >
                            {{ $t("text.edit") }}{{ $t("order.price") }}
                          </div>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                    <el-dropdown>
                      <a class="el-dropdown-link small-link">
                        {{ $t("text.more") }}
                        <i class="el-icon-arrow-down el-icon--right"></i>
                      </a>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                          <div class="font10" @click="copyOrder(row)">
                            {{ $t("action.copy") }}
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item
                          v-if="canDelOrder(row) && financeVerifyInfoDF(row)"
                        >
                          <div
                            class="font10"
                            @click="deleteOrder(row, rowIndex)"
                          >
                            {{ $t("text.delete") }}
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="!row.hurry">
                          <div
                            class="font10"
                            @click="editOrderHurry(row, rowIndex)"
                          >
                            {{ $t("order.hurry") }}
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item
                          v-if="
                            row.confirmAt == null &&
                            Permit.canActionsChargeEdition('orderConfirm')
                          "
                        >
                          <div
                            class="font10"
                            @click="confirmOrder(row, rowIndex)"
                          >
                            {{ $t("action.confirmOrder") }}
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item
                          v-if="
                            row.workflowState == 'pending' &&
                            row.follow == true &&
                            Permit.canActionsChargeEdition('orderConfirm')
                          "
                        >
                          <div
                            class="font10"
                            @click="cancelConfirmOrder(row, rowIndex)"
                          >
                            {{ $t("action.cancelConfirmOrder") }}
                          </div>
                        </el-dropdown-item>

                        <el-dropdown-item
                          v-if="
                            canCancel(row, rowIndex) &&
                            Permit.canActions('orderCancel')
                          "
                        >
                          <div class="font10" @click="cancel(row, rowIndex)">
                            {{ $t("order.cancel") }}
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item
                          v-if="
                            canReturnBack(row, rowIndex) &&
                            Permit.canActions('orderReturn')
                          "
                        >
                          <div
                            class="font10"
                            @click="returnBack(row, rowIndex)"
                          >
                            {{ $t("order.return") }}
                          </div>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </vxe-table-column>
              </vxe-table>
              <div class="flex flex-between pager">
                <div class="selected-qty-tips">
                  选中了
                  <span class="strong">{{ selectRecordQty }} </span>条记录
                </div>
                <div>
                  <vxe-pager
                    size="small"
                    :loading="false"
                    :background="false"
                    :current-page="pager.currentPage"
                    :page-size="pager.pageSize"
                    :total="pager.total"
                    :layouts="pagerConfig.layouts"
                    :page-sizes="pagerConfig.pageSizes"
                    @page-change="changePager"
                  ></vxe-pager>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('text.log')" name="log">
            <div class="drawer-content with-tab">
              <div class="box">
                <el-timeline>
                  <el-timeline-item
                    v-for="(log, index) in logs"
                    :key="index"
                    :timestamp="log.doAt"
                  >
                    <span v-if="log.doBy != null" style="color: #909399">{{
                      log.doBy
                    }}</span>
                    <raw-html :content="log.content"></raw-html>
                  </el-timeline-item>
                </el-timeline>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 编辑收款 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editPaymentDF"
      width="30%"
      destroy-on-close
    >
      <el-form
        ref="editPaymentObjForm"
        :model="editPaymentObj"
        label-width="60px"
      >
        <el-form-item
          :label="$t('payment.total')"
          :prop="'total'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('payment.total')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="editPaymentObj.total"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('payment.payMethod')"
          :prop="'payMethodId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('payment.payMethod')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select v-model="editPaymentObj.payMethodId" clearable filterable>
            <el-option
              v-for="payMethod in payMethods"
              :key="payMethod.id"
              :label="payMethod.name"
              :value="payMethod.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('payment.paidAt')"
          :prop="'paidAt'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('payment.paidAt')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-date-picker
            v-model="editPaymentObj.paidAt"
            type="date"
            style="width: 100%"
            :picker-options="pickerOptionsSevenDays"
          />
        </el-form-item>
        <el-form-item :label="$t('payment.explain')" :prop="'explain'">
          <el-input v-model="editPaymentObj.explain" />
        </el-form-item>
        <el-form-item :label="$t('payment.voucher')" :prop="'voucher'">
          <dropzone v-model="editPaymentObj.voucher" multiple />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="editPaymentDoing"
          size="small"
          @click="editPaymentSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editPaymentDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <drawer
      :title="$t('text.view', [$t('menu.orders')])"
      :visible.sync="show"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRowId" />
    </drawer>

    <drawer
      :title="$t('text.edit', [$t('menu.orders')])"
      :visible.sync="editOrderDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <edit-order :id="currentRowOrderId" @updateInfo="orderUpdated" />
    </drawer>
    <el-dialog
      :title="$t('action.copy')"
      :close-on-click-modal="false"
      v-if="copyOrderDF"
      :visible.sync="copyOrderDF"
      width="30%"
    >
      <copy-order
        :id="currentRowOrderId"
        @updated="copyUpdated"
        @close="copyOrderDF = false"
        source="bargainsBulkOrder"
      />
    </el-dialog>
    <!-- 编辑价格 -->
    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editOrderPriceDF"
      width="30%"
    >
      <el-form
        ref="editOrderPriceObjForm"
        :model="editOrderPriceObj"
        label-width="80px"
      >
        <el-form-item
          :prop="'price'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('order.price')]),
              trigger: 'blur',
            },
          ]"
          :label="$t('order.price')"
        >
          <el-input
            size="small"
            v-model.trim="editOrderPriceObj.price"
            :placeholder="$t('order.price')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :prop="'settlementRemark'"
          :label="$t('order.settlementRemark')"
        >
          <el-input
            size="small"
            v-model.trim="editOrderPriceObj.settlementRemark"
            :placeholder="$t('order.settlementRemark')"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editOrderPriceDoing"
          size="small"
          @click="editOrderPriceSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editOrderPriceDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 客户取消 -->
    <el-dialog
      :title="$t('order.cancel')"
      :close-on-click-modal="false"
      :visible.sync="cancelDF"
      width="30%"
    >
      <el-form ref="cancelObjForm" :model="cancelObj" label-width="90px">
        <el-form-item
          v-if="row && row._bargain && row._bargain.settleType == 'now'"
          :prop="'total'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('returnBack.total')]),
              trigger: 'blur',
            },
          ]"
          :label="$t('returnBack.total')"
        >
          <el-input
            size="small"
            v-model.trim="cancelObj.total"
            :placeholder="$t('returnBack.total')"
          />
        </el-form-item>

        <el-form-item
          v-if="row && row._bargain && row._bargain.settleType == 'now'"
          :prop="'payMethodId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('returnBack.payMethod')]),
              trigger: 'blur',
            },
          ]"
          :label="$t('returnBack.payMethod')"
        >
          <el-select
            size="small"
            v-model="cancelObj.payMethodId"
            filterable
            clearable
          >
            <el-option
              v-for="payMethod in payMethods"
              :key="payMethod.id"
              :label="payMethod.name"
              :value="payMethod.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :prop="'reason'" :label="$t('order.cancelReason')">
          <el-input
            size="small"
            v-model.trim="cancelObj.reason"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="cancelDoing"
          size="small"
          @click="cancelSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="cancelDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 客户退货 -->
    <el-dialog
      :title="$t('order.return')"
      :close-on-click-modal="false"
      :visible.sync="returnDF"
      width="30%"
    >
      <el-form ref="returnObjForm" :model="returnObj" label-width="90px">
        <el-form-item prop="reason" :label="$t('returnBack.haveGood')">
          <el-checkbox v-model="returnObj.haveGood"></el-checkbox>
        </el-form-item>
        <el-form-item
          v-if="row && row._bargain && row._bargain.settleType == 'now'"
          prop="total"
          :label="$t('returnBack.total')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('returnBack.total')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="returnObj.total" />
        </el-form-item>
        <el-form-item
          v-if="row && row._bargain && row._bargain.settleType == 'now'"
          :prop="'payMethodId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('returnBack.payMethod')]),
              trigger: 'blur',
            },
          ]"
          :label="$t('returnBack.payMethod')"
        >
          <el-select
            size="small"
            v-model="returnObj.payMethodId"
            filterable
            clearable
          >
            <el-option
              v-for="payMethod in payMethods"
              :key="payMethod.id"
              :label="payMethod.name"
              :value="payMethod.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="returnObj.haveGood == true"
          prop="returnTracking"
          :label="$t('returnBack.returnTracking')"
        >
          <el-input
            size="small"
            v-model.trim="returnObj.returnTracking"
          ></el-input>
        </el-form-item>

        <el-form-item prop="reason" :label="$t('order.returnReason')">
          <el-input
            size="small"
            v-model.trim="returnObj.reason"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="returnDoing"
          size="small"
          @click="submitReturnBack"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="returnDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 打印列表 -->
    <div id="printListDiv" style="display: none">
      <div style="width: 100%; font-size: 12px">
        <table
          style="
            width: 100%;
            border-collapse: collapse;
            border: 1px solid black;
            text-align: left;
            margin-bottom: 20px;
            padding: 5px;
            font-size: 12px;
          "
        >
          <tr style="border: 1px solid black; text-align: center">
            <td style="border: 1px solid black; width: 120px">
              {{ $t("order.serialNo") }}
            </td>
            <td style="border: 1px solid black; width: 100px">
              {{ $t("product.productNo") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("product.category") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("menu.brands") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("product.color") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("product.size") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("text.remark") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("product.specJson") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("text.quantity") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("text.handOverAt") }}
            </td>
            <td style="border: 1px solid black; width: 60px">
              {{ $t("text.owner") }}
            </td>
            <td style="border: 1px solid black; width: 80px">
              {{ $t("text.createAt") }}
            </td>
          </tr>

          <tr
            style="border: 1px solid black; text-align: center"
            v-for="(item, itemIndex) in selectRecords"
            :key="itemIndex"
          >
            <td style="border: 1px solid black">{{ item.serialNo }}</td>

            <td style="border: 1px solid black">{{ item.productNo }}</td>
            <td style="border: 1px solid black">
              {{ item.categoryName || "" }}
            </td>
            <td style="border: 1px solid black">
              {{ item.productBrand || "" }}
            </td>
            <td style="border: 1px solid black">{{ item.color || "" }}</td>
            <td style="border: 1px solid black">{{ item.size || "" }}</td>
            <td style="border: 1px solid black">
              <raw-html :content="item.remark"></raw-html>
            </td>
            <td style="border: 1px solid black">
              {{ Util.tranJSONArrToString(item.specJson) }}
            </td>
            <td style="border: 1px solid black">
              {{ item.quantity }}{{ item.unit }}
            </td>
            <td style="border: 1px solid black">{{ item.handOverAt }}</td>

            <td style="border: 1px solid black">{{ item.ownerName }}</td>
            <td style="border: 1px solid black">{{ item.createAt }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import { flagsWithClear, flagsWithNone } from "@/utils/enums.js";
import RawHtml from "@/components/RawHtml";
import DateRange from "@/components/DateRange";
import Currency from "@/components/Currency";
import Dropzone from "@/components/Dropzone";
import ThumbnailText from "@/components/ThumbnailText";
import Cookies from "js-cookie";
import User from "@/api/user.js";
import Order from "@/api/order.js";
import Brand from "@/api/brand";
import Category from "@/api/category";
import Show from "@/views/oms/bargains/showOrder.vue";
import EditOrder from "@/views/oms/bargains/editOrder.vue";
import copyOrder from "@/views/oms/bargains/copyOrder.vue";

import Log from "@/api/log.js";
import Bargain from "@/api/bargain.js";
import PayMethod from "@/api/payMethod.js";
import Delivery from "@/api/delivery.js";
import Payment from "@/api/payment.js";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    Show,
    RawHtml,
    DateRange,
    Currency,
    Dropzone,
    ThumbnailText,
    EditOrder,
    copyOrder,
  },

  data() {
    return {
      Util: Util,
      flags: flagsWithClear,
      narrows: [
        [
          {
            label: this.$t("order.nearRange"),
            items: Order.nearRange,
          },
          {
            label: this.$t("order.passRange"),
            items: Order.passRange,
          },
          {
            label: this.$t("text.flag"),
            items: flagsWithNone.map((flag) => {
              return { flag: flag, key: flag, condition: { flag: flag } };
            }),
          },
        ],
        [
          {
            label: this.$t("text.special"),
            items: [
              {
                label: this.$t("order.hurry"),
                key: "hurryYes",
                condition: { hurry: "yes" },
              },
              {
                label: "已发货未收货",
                key: "unReceiveYes",
                condition: { unReceive: "yes" },
              },
            ],
          },
          {
            label: this.$t("action.reportMonthSettlement"),
            items: [
              {
                label: this.$t("boolean.true"),
                key: "orderBillYes",
                condition: { orderBill: "yes" },
              },
              {
                label: this.$t("boolean.false"),
                key: "orderBillNo",
                condition: { orderBill: "no" },
              },
            ],
          },
        ],
      ],
      searchForm: {
        serialNo: null,
        productNo: null,
        categoryName: null,
        color: null,
        size: null,
        ownerId: null,
        createAtStartAt: null,
        createAtEndAt: null,
        finishAtStartAt: null,
        finishAtEndAt: null,
        customerReceiveAtStartAt: null,
        customerReceiveAtEndAt: null,
        specJson: null,
      },
      sorter: {
        sortBy: "orders_id",
        sortIndicator: "desc",
      },
      sorterMap: {
        productNo: "orders_productNo",
        handOverAt: "orders_handOverAt",
      },
      saleSearchCount: null,
      users: [],
      categories: [],

      activeName: "detail",
      bargain: {},
      logs: [],

      //
      currentRowId: null,
      currentRowIdx: null,
      show: false,
      //
      currentRowOrderId: null,
      editOrderDF: false,
      deliveries: [],
      //
      //编辑收款
      pickerOptionsSevenDays: {
        disabledDate(time) {
          const curDate = new Date().getTime();
          const day = 90 * 24 * 3600 * 1000;
          const threeMonths = curDate - day;
          return time.getTime() > Date.now() || time.getTime() < threeMonths;
        },
      },
      editPaymentDF: false,
      payMethods: [],
      currentRowIdx: null,
      row: null,
      editPaymentObj: {
        total: null,
        payMethodId: null,
        payMethodName: null,
        explain: null,
        voucher: null,
        paidAt: null,
      },
      editPaymentDoing: false,
      // 编辑成交单价
      editOrderPriceDF: false,
      editOrderPriceObj: {
        uuid: null,
        price: null,
        settlementRemark: null,
      },
      editOrderPriceDoing: false,
      // 取消
      payMethods: [],
      cancelDF: false,
      cancelObj: {
        id: null,
        total: null,
        reason: null,
        payMethodId: null,
        payMethodName: null,
        returnPayment: true,
      },
      cancelDoing: false,
      // 退货
      returnDF: false,
      returnObj: {
        haveGood: true,
        total: null,
        reason: null,
        payMethodId: null,
        payMethodName: null,
        returnTracking: null,
        id: null,
      },
      returnDoing: false,
      // 复制订单
      copyOrderDF: false,
    };
  },
  computed: {
    implicit() {
      return {
        bargainId: this.$route.params.id,
      };
    },
  },
  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
    this.handleClickTab();
    this.narrowsWorkflowStates();
    this.getEntity();
  },
  methods: {
    handleClickTab(tab, event) {
      if (this.activeName == "detail") {
        this.getBargain();
      }
      if (this.activeName == "order") {
      }
      if (this.activeName == "log") {
        this.getLogs();
      }
    },

    getBargain() {
      const self = this;
      self.loadingStart();
      Bargain.findById(this.$route.params.id).then(function (res) {
        if (res.data.code === 200) {
          self.bargain = res.data.entity;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
    getEntity() {
      const self = this;
      axios
        .all([
          User.findByTenantId(self.Permit.currentTenant().id),
          Brand.findByTenantId(),
          Category.findByTenantId(),
        ])
        .then(
          axios.spread(function (users, brands, categories) {
            if (users.status === 200) {
              self.users = users.data.filter((u) => u.authorize === true);
            } else {
              self.sysError();
            }
            if (brands.status === 200) {
              self.brands = brands.data;
              self.narrowsBrands();
            } else {
              self.sysError();
            }
            if (categories.status === 200) {
              self.categories = categories.data;
            } else {
              self.sysError();
            }
          })
        );
    },
    //
    getLogs() {
      const self = this;
      Log.forEntity("Bargain", this.$route.params.id).then(function (res) {
        self.logs = res.data;
      });
    },

    // -----财务审核权限
    financeVerifyInfoDF() {
      const financeVerifyInfoDF =
        this.Permit.currentTenant().config.financeVerifyStrict === false ||
        (this.Permit.currentTenant().config.financeVerifyStrict &&
          (this.bargain.financeAudit == null ||
            (this.bargain.financeAudit != null &&
              this.bargain.financeAudit.dealType === "reject")));
      return financeVerifyInfoDF;
    },
    // 删除收款
    deletePayment(row, rowIndex) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        Payment.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.bargain.payments.splice(rowIndex, 1);
            self.bargain.payAmount = self.bargain.payAmount - row.total;
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑收款
    editPayment(row, rowIndex) {
      const self = this;
      self.currentRowIdx = rowIndex;
      self.row = row;
      self.editPaymentObj.total = row.total;
      self.editPaymentObj.explain = row.explain;
      self.editPaymentObj.voucher = row.voucher;
      self.editPaymentObj.paidAt = row.paidAt;
      PayMethod.findByTypes({ types: PayMethod.saleTypes }).then(function (
        res
      ) {
        if (res.status === 200) {
          self.payMethods = res.data;
          if (self.payMethods.find((p) => p.id == row.payMethodId) != null) {
            self.editPaymentObj.payMethodId = row.payMethodId;
            self.editPaymentObj.payMethodName = row.payMethodName;
          }
          self.editPaymentDF = true;
        } else {
          self.sysError();
        }
      });
    },
    editPaymentSubmit() {
      const self = this;
      this.$refs.editPaymentObjForm.validate((valid) => {
        if (valid) {
          // if (!Util.regexQuantity(self.editPaymentObj.total)) {
          //   self.$message({
          //     message: self.$t("rules.regex", [self.$t("payment.total")]),
          //     type: "warning",
          //   });
          //   return;
          // }

          self.editPaymentObj.payMethodName = self.payMethods.find(
            (p) => p.id === this.editPaymentObj.payMethodId
          ).name;
          self.editPaymentObj.paidAt =
            Util.formatDate(self.editPaymentObj.paidAt) + " 00:00:00";
          self.editPaymentDoing = true;
          Payment.update(self.row.id, self.editPaymentObj).then(function (res) {
            if (res.status === 200) {
              self.bargain.payments[self.currentRowIdx].total =
                self.editPaymentObj.total;
              self.bargain.payments[self.currentRowIdx].payMethodName =
                self.editPaymentObj.payMethodName;
              self.bargain.payments[self.currentRowIdx].explain =
                self.editPaymentObj.explain;
              self.bargain.payments[self.currentRowIdx].voucher =
                self.editPaymentObj.voucher;
              self.bargain.payments[self.currentRowIdx].paidAt =
                self.editPaymentObj.paidAt;
              let total = 0;
              for (const p of self.bargain.payments) {
                total = total + Number(p.total);
              }
              self.bargain.payAmount = total;
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.editPaymentDoing = false;
              self.editPaymentDF = false;
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    //order==============================
    // 获取发货信息
    getDeliveries(row) {
      const self = this;
      Delivery.findByOrderUuid(row.uuid).then(function (res) {
        if (res.status == 200) {
          self.deliveries = res.data;
        } else {
          self.sysError();
        }
      });
    },

    copyUpdated() {
      this.loadData();
      this.copyOrderDF = false;
    },
    copyOrder(row) {
      this.currentRowOrderId = row.id;
      this.copyOrderDF = true;
    },
    // 退货
    canReturnBack(row, rowIndex) {
      return (
        row.follow === true &&
        row.workflowState === "finished" &&
        row.workflowState !== "returned" &&
        row.workflowState !== "canceled"
      );
    },
    returnBack(row, rowIndex) {
      this.row = row;
      this.currentRowIdx = rowIndex;
      this.returnObj.haveGood = true;
      this.returnObj.reason = null;
      this.returnObj.total = row.price * row.quantity;
      this.returnObj.payMethodId = null;
      this.returnObj.payMethodName = null;
      this.returnObj.id = row.id;
      if (
        this.row &&
        this.row._bargain &&
        this.row._bargain.settleType == "now"
      ) {
        this.getPayMethods(row);
      }
      this.returnDF = true;
    },
    submitReturnBack() {
      const self = this;
      self.$refs.returnObjForm.validate((valid) => {
        if (valid) {
          if (this.bargain && this.bargain.settleType == "now") {
            if (!Util.regexQuantity(self.returnObj.total)) {
              self.$message({
                message: self.$t("rules.regex", [self.$t("returnBack.total")]),
                type: "warning",
              });
              return;
            }
            self.returnObj.payMethodName = self.payMethods.find(
              (p) => p.id === self.returnObj.payMethodId
            ).name;
          }
          self.returnDoing = true;
          Order.returnBack(self.returnObj).then(function (res) {
            if (res.status == 200) {
              self.records[self.currentRowIdx].workflowState = "returned";
              self.$message({
                message: self.$t("prompt.returnSuccess"),
                type: "success",
              });
              self.returnDoing = false;
              self.returnDF = false;
              self.$eventHub.$emit("orderReturnBack");
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 取消
    canCancel(row) {
      return (
        row.follow === true &&
        row.workflowState !== "canceled" &&
        row.workflowState !== "returned" &&
        [
          "confirming",
          "pending",
          "preparing",
          "prepared",
          "processing",
          "processed",
          "purchasing",
          "purchased",
          "forout",
        ].includes(row.workflowState)
      );
    },
    cancel(row, rowIndex) {
      this.row = row;
      this.currentRowIdx = rowIndex;
      this.cancelObj.reason = null;
      this.cancelObj.total = null;
      this.cancelObj.payMethodId = null;
      this.cancelObj.payMethodName = null;
      this.cancelObj.id = row.id;
      if (this.bargain && this.bargain.settleType == "now") {
        this.getPayMethods(row);
      }
      this.cancelDF = true;
    },
    getPayMethods(row) {
      const self = this;
      PayMethod.findByTypes({ types: PayMethod.saleTypes }).then(function (
        res
      ) {
        if (res.status === 200) {
          self.payMethods = res.data;
          if (row._bargain.customerId != null) {
            Customer.findById(row._bargain.customerId).then(function (res) {
              if (res.data.code === 200) {
                if (row.currency === "CNY" && res.data.entity != null) {
                  self.payMethods.push({
                    id: -1,
                    // name: "账户余额(¥" + res.data.entity.balance + ")",
                    name: "账户余额",
                  });
                }
              } else {
                self.sysError();
              }
            });
          }
        } else {
          self.sysError();
        }
      });
    },
    cancelSubmit() {
      const self = this;
      self.$refs.cancelObjForm.validate((valid) => {
        if (valid) {
          if (this.bargain && this.bargain.settleType == "now") {
            if (!Util.regexQuantity(self.cancelObj.total)) {
              self.$message({
                message: self.$t("rules.regex", [self.$t("returnBack.total")]),
                type: "warning",
              });
              return;
            }
            self.cancelObj.payMethodName = self.payMethods.find(
              (p) => p.id === self.cancelObj.payMethodId
            ).name;
          }
          self.cancelDoing = true;
          Order.cancel(self.cancelObj).then(function (res) {
            if (res.status == 200) {
              self.loadData();
              self.$message({
                message: self.$t("prompt.cancelSuccess"),
                type: "success",
              });
              self.cancelDoing = false;
              self.cancelDF = false;
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 取消确认
    cancelConfirmOrder(row, rowIndex) {
      const self = this;
      Order.batchCancelConfirm([row.id]).then(function (res) {
        if (res.status == 200) {
          self.records[rowIndex].confirmAt = null;
          self.records[rowIndex].workflowState = "confirming";
          self.$message({
            message: self.$t("prompt.cancelConfirmSuccess"),
            type: "success",
          });
          self.$eventHub.$emit("cancelConfirm");
        } else {
          self.sysError();
        }
      });
    },
    //确认
    confirmOrder(row, rowIndex) {
      const self = this;
      Order.batchConfirm([row.id]).then(function (res) {
        if (res.status == 200) {
          self.records[rowIndex].confirmAt = Util.formatDate(new Date());
          self.records[rowIndex].workflowState = "pending";
          self.$message({
            message: self.$t("prompt.confirmSuccess"),
            type: "success",
          });
          self.$eventHub.$emit("orderBatchConfirm");
        } else {
          self.sysError();
        }
      });
    },
    //加急
    editOrderHurry(row, rowIndex) {
      const self = this;
      Order.hurry(row.id).then(function (res) {
        if (res.status === 200) {
          self.records[rowIndex].hurry = true;
          self.$message({
            message: self.$t("prompt.hurrySuccess"),
            type: "success",
          });
        } else {
          self.sysError();
        }
      });
    },
    // 删除子订单
    canDelOrder(row) {
      return (
        ["confirming", "pending"].includes(row.workflowState) &&
        (row.follow === true ||
          (row.follow === false && row.retrieveAt != null))
      );
    },
    deleteOrder(row, rowIndex) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        Order.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.loadData();
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.$eventHub.$emit("deleteOrder");
          } else {
            self.sysError();
          }
        });
      }
    },

    //编辑成交单价
    editOrderPrice(row, rowIndex) {
      this.row = row;
      this.currentRowIdx = rowIndex;
      this.editOrderPriceObj.uuid = row.uuid;
      this.editOrderPriceObj.price = row.price;
      if (row.settlementRemark != null) {
        this.editOrderPriceObj.settlementRemark = row.settlementRemark;
      } else {
        this.editOrderPriceObj.settlementRemark =
          Cookies.get("settlementRemark");
      }

      this.editOrderPriceDF = true;
    },
    editOrderPriceSubmit() {
      const self = this;
      self.$refs.editOrderPriceObjForm.validate((valid) => {
        if (valid) {
          if (!Util.regexQuantity(self.editOrderPriceObj.price)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("order.price")]),
              type: "warning",
            });
            return;
          }
          self.editOrderPriceDoing = true;
          Order.updatePrice(self.editOrderPriceObj).then(function (res) {
            if (res.status == 200) {
              self.records[self.currentRowIdx].price =
                self.editOrderPriceObj.price;
              self.records[self.currentRowIdx].settlementRemark =
                self.editOrderPriceObj.settlementRemark;
              Cookies.set(
                "settlementRemark",
                self.editOrderPriceObj.settlementRemark
              );
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.editOrderPriceDoing = false;
              self.editOrderPriceDF = false;
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    // 编辑
    editOrder(row, rowIndex) {
      this.currentRowOrderId = row.id;
      this.currentRowIdx = rowIndex;
      this.editOrderDF = true;
    },
    orderUpdated(order) {
      for (const key in this.records[this.currentRowIdx]) {
        this.records[this.currentRowIdx][key] = order[key];
      }
      this.editOrderDF = false;
    },

    //============================
    narrowsBrands() {
      if (this.brands.length != 0) {
        this.narrows.push([
          {
            label: this.$t("product.brand"),
            items: this.brands.map((brand) => {
              return {
                label: brand.name,
                key: brand.name,
                condition: { productBrand: brand.name },
              };
            }),
          },
        ]);
      }
    },
    narrowsWorkflowStates() {
      const self = this;
      if (self.Permit.canActions("orderDealView")) {
        var states = ["pending"];
        if (self.Permit.canActionsConfigDealType("available")) {
          states = states.concat(Order.states_available);
        }
        if (self.Permit.canActionsConfigDealType("purchase")) {
          states = states.concat(Order.states_purchase);
        }
        if (self.Permit.canActionsConfigDealType("manufacture")) {
          states = states.concat(Order.states_manufacture);
        }
        self.narrows.push([
          {
            label: self.$t("text.workflowState"),
            items: states.concat(Order.states_after).map((s) => {
              return {
                key: s,
                label: self.$t("orderStates." + s),
                condition: { workflowStates: [s] },
              };
            }),
          },
        ]);
      } else {
        self.narrows.push([
          {
            label: self.$t("text.workflowState"),
            items: Order.states_no_permint_replenish.map((s) => {
              return {
                key: s.key,
                label: self.$t("orderStates." + s.key),
                condition: { workflowStates: s.workflowStates },
              };
            }),
          },
        ]);
      }
      if (window.location.href.indexOf("unconfirms") != -1) {
        self.initFilter = "confirming";
      } else {
        self.initFilter = null;
      }
    },

    print(type) {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(self.$t("prompt.atLeastOneValidData"));
        return;
      }
      self.printFunction(type);
    },
    // 下载
    download(type) {
      const self = this;
      if (type == "checked") {
        if (!self.downloadChecked(self.selectRecords)) {
          return;
        }
        const data = {
          currentPage: 1,
          pageSize: self.limitNumber(),
          ids: self.selectRecords.map((c) => c.id),
        };
        self.downloadData(data);
      } else {
        if (!self.downloadSearch(self.pager.total)) {
          return;
        }
        const data = JSON.parse(JSON.stringify(self.combineParams()));
        data.pageSize = self.limitNumber();
        self.downloadData(data);
      }
    },
    downloadData(data) {
      const self = this;
      Order.saleExportExcel(data).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.loadData();
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },

    //=====

    // 确认订单
    batchConfirm() {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      const ordersProductNoIsNull = self.selectRecords.filter(
        (o) => o.productNo == null || o.productNo == ""
      );
      if (ordersProductNoIsNull.length == self.selectRecords.length) {
        self.$message({
          message: self.$t("prompt.orderConfirmPromptProductNoIsNull"),
          type: "warning",
        });
        return;
      }
      const ordersConfirmed = self.selectRecords.filter(
        (o) => o.workflowState !== "confirming"
      );
      if (ordersConfirmed.length == self.selectRecords.length) {
        self.$message({
          message: self.$t("prompt.orderConfirmPromptIsConfirmed"),
          type: "warning",
        });
        return;
      }

      const ids = self.selectRecords
        .filter(
          (o) =>
            o.productNo != null &&
            o.productNo != "" &&
            o.workflowState == "confirming"
        )
        .map((o) => o.id);
      if (ids.length === 0) {
        self.$message.error(self.$t("prompt.atLeastOneDataNoConfirm"));
        return;
      }
      self.batchConfirmDoing = true;
      Order.batchConfirm(ids).then(function (res) {
        if (res.status == 200) {
          self.batchConfirmDoing = false;
          if (ids.length === self.selectRecords.length) {
            self.$message({
              message: self.$t("prompt.confirmSuccess"),
              type: "success",
            });
          } else {
            const text =
              "总共确认" +
              self.selectRecords.length +
              "订单项，成功" +
              ids.length +
              "条，失败" +
              (self.selectRecords.length - ids.length) +
              "条,失败原因：订单项没有货号或已经确认";
            self.$message({
              message: text,
              type: "warning",
            });
          }
          self.loadData();
          self.$eventHub.$emit("orderBatchConfirm");
        } else {
          self.sysError();
        }
      });
    },
    // 标旗帜
    selectFlag(flag) {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      const data = [];

      for (const c of self.selectRecords) {
        const obj = { uuid: c.uuid, flags: null };
        if (flag === "clear") {
          obj.flags = JSON.stringify([]);
        } else {
          const arr = c.flags != null ? JSON.parse(c.flags) : [];
          const newArr = arr.concat([flag]);
          obj.flags = JSON.stringify(newArr);
        }
        data.push(obj);
      }
      // console.log(flag, "===", data);
      Order.updateFlags(data).then(function (res) {
        if (res.status === 200) {
          for (const o of self.selectRecords) {
            o.flags = data.find((d) => d.uuid == o.uuid).flags;
          }
          self.$message({
            message: self.$t("prompt.signSuccess"),
            type: "success",
          });
          self.clearSelected();
        } else {
          self.sysError();
        }
      });
    },
    //
    showRecord(order) {
      this.currentRowId = order.id;
      this.show = true;
    },

    //======
    dataProvider(params) {
      return Order.saleSearch(params);
      //
    },
    recordsDecorate(records) {
      const self = this;
      this.records = records;
      Order.saleSearchCount(self.combineParams()).then(function (res) {
        if (res.status == 200) {
          self.saleSearchCount = res.data;
        } else {
          self.sysError();
        }
      });
    },
    isNear(row) {
      //定义近交期
      const noColorWorkflowStates = ["canceled", "returned", "finished"];
      if (
        !noColorWorkflowStates.includes(row.workflowState) &&
        row.handOverAt != null
      ) {
        if (
          Util.dateDiff(row.handOverAt, new Date()) <=
            this.Permit.currentTenant().config.nearDays &&
          Util.dateDiff(row.handOverAt, new Date()) > 0
        ) {
          return true;
        }
      }
      return false;
    },
    isPass(row) {
      //定义过交期
      const noColorWorkflowStates = ["canceled", "returned", "finished"];
      if (
        !noColorWorkflowStates.includes(row.workflowState) &&
        row.handOverAt != null
      ) {
        if (Util.dateDiff(row.handOverAt, new Date()) <= 0) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>
